export default __webpack_public_path__ + "static/media/SndLowerSTurnDowm.5ccb7812.mp3";